
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { instance, updateAuthorizationHeader } from "./mainAxios";
import { auth, db } from "./firabaseConfig";
import { collection, getDocs, query, where } from "firebase/firestore";


const signOutUser = async () => {
  await signOut(auth)
}
const register = (userDetails) => {
  const path = "/users/register";
  return new Promise(async (resolve, reject) => {
    try {
      const res = await instance.post(path, userDetails);
      resolve(res);
    } catch (error) {
      reject(error);
    }
  });
};

//Login
// const login = (userDetails) => {
//   const path = "/teacher/login-teacher";
//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await instance.post(path, userDetails);
//       resolve(res);
//     } catch (error) {
//       reject(error);
//     }
//   });
// };

const login = async (userDetails) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, userDetails.email, userDetails.password)
    let user = await getTeacherDetailsByEmail(userCredential.user.email)
    localStorage.setItem("access_token", userCredential.user.accessToken);
    return { user: user, token: userCredential.user.accessToken }
    // return userCredential
  } catch (error) {
    console.log("🚀 ~ file: authRequests.js:23 ~ login ~ error:", error)
    throw error
  }
};

// const trylogin = () => {
//   const path = "/teacher/getUser";
//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await instance.get(path);
//       resolve(res);
//     } catch (error) {
//       reject(error);
//     }
//   });
// };
const trylogin = async (userInfo) => {
  try {
    if (userInfo.accessToken == localStorage.access_token) {

      let user = await getTeacherDetailsByEmail(userInfo.email);
      if (user) {
        console.log("🚀 ~ file: authRequests.js:62 ~ trylogin ~ user:", user)
        return user
      } else {
        throw { message: "not allowed" }
      }

    } else {
      throw { message: "token is invalid" }
    }

  } catch (error) {
    console.log("🚀 ~ file: authRequests.js:64 ~ trylogin ~ error:", error)
    throw error
  }
};

//
//RefreshToken
const refreshToken = (refToken) => {
  let path = "/users/token";
  updateAuthorizationHeader(refToken)
  return new Promise(async (resolve, reject) => {
    try {
      const res = await instance.post(path);
      resolve(res);
    } catch (error) {
      reject(error);
    }
  });
};
//
//

const getTeacherDetailsByEmail = async (email) => {
  console.log("🚀 ~ getTeacherDetailsByEmail ~ email:", email)
  try {//TODO: adding rule to prevent data leak
    const userRef = collection(db, "users");
    let q = query(userRef, where("email", "==", email));
    let userSnap = (await getDocs(q)).docs.map(doc => ({ ...doc.data(), id: doc.id }));
    console.log("🚀 ~ getTeacherDetailsByEmail ~ userSnap:", userSnap)
    let user = userSnap[0]
    if (user) {
      console.log("🚀 ~ getTeacherDetailsByEmail ~ user:", user)
      // await populateByField(user, "all")
      // let newUser = await updateUserDetails({ ...user, id: null }, user.id)
      return user
    } else {
      return false
    }
  } catch (error) {
    console.log("🚀 ~ file: userRequests.js:58 ~ getUserDetails ~ error:", error)

  }

};


const authRequets = { signOutUser, register, login, refreshToken, trylogin };
export default authRequets;
